import Nullstack from 'nullstack';
export default function IconToolsOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-tools-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M16 12l4 -4a2.828 2.828 0 1 0 -4 -4l-4 4m-2 2l-7 7v4h4l7 -7"
  }), "   ", Nullstack.element("path", {
    d: "M14.5 5.5l4 4"
  }), "   ", Nullstack.element("path", {
    d: "M12 8l-5 -5m-2.004 2.004l-1.996 1.996l5 5"
  }), "   ", Nullstack.element("path", {
    d: "M7 8l-1.5 1.5"
  }), "   ", Nullstack.element("path", {
    d: "M16 12l5 5m-2 2l-2 2l-5 -5"
  }), "   ", Nullstack.element("path", {
    d: "M16 17l-1.5 1.5"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}